<div class="loading-overlay">
    <mat-spinner diameter="40" class="grid-spinner"></mat-spinner>
    @if (loadingText()) {
        <div class="loading-text">{{loadingText()}}</div>
    }
</div>